import $ from 'jquery';

const pageLinkInit = component => {
    $(component).click(e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const linkId = $this.find('a').attr('href');
        const $mobileHeader = $('.s-mobile-header');
        const $formHeader = $('.s-form-header');
        const $fixedHeader = $('.fixed-header-bar');
        const headerHeight = $mobileHeader.length > 0 ?
            $fixedHeader.height() : $formHeader.height();

        if ($(`${linkId}`).length > 0) {
            const scrollPos = $(window).width() < 768 && $mobileHeader.length > 0 ?
                $(`${linkId}`).offset().top - headerHeight : $(`${linkId}`).offset().top;
            $('html,body').animate({ scrollTop: scrollPos }, 'slow');
        }
    });
};

$(() => {
    const $pageLink = $('.link-item');

    if ($pageLink.length) {
        pageLinkInit($pageLink);
    }
});



// WEBPACK FOOTER //
// ./src/components/page-links/c-page-links.js